var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3999 7C21.3999 6.81048 21.2927 6.63725 21.1232 6.55262C20.9536 6.46799 20.7507 6.48652 20.5993 6.60046L13.4652 11.968L9.27151 7.3084C9.11003 7.12897 8.8434 7.09054 8.63782 7.21705L2.63785 10.9093C2.48998 11.0003 2.3999 11.1615 2.3999 11.3352V18.1425C2.3999 18.4187 2.62376 18.6425 2.8999 18.6425H20.8999C21.176 18.6425 21.3999 18.4187 21.3999 18.1425V7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/Graph Icon.1b168ba7a7c662c8a4d08a58a70b9620.svg";
export { ForwardRef as ReactComponent };